import { useEffect, useRef, useState } from 'react'
import './OfferBannerSection.css'
import discount_banner from '../../../assets/images/discount_banner.jpeg'
import { appUrl } from '@astro/config'
const PARTICLES = [
  { top: '22%', left: '52%', size: 5, color: 'rgba(245,158,11,0.55)', glow: '0 0 10px rgba(245,158,11,0.35)', delay: '0s' },
  { top: '68%', left: '58%', size: 3, color: 'rgba(217,119,6,0.45)', glow: '0 0 8px rgba(217,119,6,0.25)', delay: '.9s' },
  { top: '35%', left: '75%', size: 4, color: 'rgba(245,158,11,0.40)', glow: '0 0 9px rgba(245,158,11,0.22)', delay: '1.7s' },
  { top: '78%', left: '44%', size: 3, color: 'rgba(180,83,9,0.50)', glow: 'none', delay: '2.3s' },
]

export default function OfferBannerSection() {
  const contentRef = useRef(null)
  const [visible, setVisible] = useState(false)
  const [ctaHover, setCtaHover] = useState(false)

  useEffect(() => {
    const el = contentRef.current
    if (!el) return undefined
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return
        setVisible(true)
        observer.disconnect()
      },
      { threshold: 0.15 },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <section
      id="offer-banner"
      className="relative w-full overflow-hidden flex items-center"
      style={{ minHeight: 'clamp(300px,42vw,440px)', padding: 'clamp(48px,5vw,72px) 0' }}
    >
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div className="absolute inset-0" style={{ backgroundImage: `url('${discount_banner}')`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} />
        <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.58)' }} />
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 56% 90% at 72% 50%,rgba(180,83,9,0.22) 0%,rgba(120,40,5,0.10) 45%,transparent 70%)' }} />
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 40% 55% at 8% 15%,rgba(245,158,11,0.06) 0%,transparent 60%)' }} />
        <div className="absolute left-0 right-0" style={{ top: '50%', transform: 'translateY(-50%)', height: '1px', background: 'linear-gradient(90deg,transparent,rgba(217,119,6,0.14) 30%,rgba(217,119,6,0.14) 70%,transparent)' }} />
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.025, pointerEvents: 'none' }}>
          <filter id="ob-noise">
            <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="4" stitchTiles="stitch" />
            <feColorMatrix type="saturate" values="0" />
          </filter>
          <rect width="100%" height="100%" filter="url(#ob-noise)" />
        </svg>
      </div>

      <div className="absolute pointer-events-none" aria-hidden="true" style={{ right: '-2%', top: '50%', transform: 'translateY(-50%)', width: 'min(400px,38vw)', height: 'min(400px,38vw)', opacity: 0.9 }}>
        <svg viewBox="0 0 400 400" fill="none" stroke="currentColor" className="w-full h-full" style={{ color: 'rgba(180,83,9,0.13)' }}>
          <circle cx="200" cy="200" r="196" strokeWidth="0.5" />
          <circle cx="200" cy="200" r="162" strokeWidth="0.5" strokeDasharray="2 5" />
          <circle cx="200" cy="200" r="124" strokeWidth="0.5" />
          <circle cx="200" cy="200" r="84" strokeWidth="0.4" strokeDasharray="1 4" />
          <line x1="200" y1="4" x2="200" y2="396" strokeWidth="0.3" />
          <line x1="4" y1="200" x2="396" y2="200" strokeWidth="0.3" />
          <line x1="57" y1="57" x2="343" y2="343" strokeWidth="0.3" />
          <line x1="343" y1="57" x2="57" y2="343" strokeWidth="0.3" />
          <circle cx="200" cy="200" r="10" strokeWidth="0.6" fill="rgba(180,83,9,0.08)" />
          <circle cx="200" cy="200" r="4" strokeWidth="0" fill="rgba(217,119,6,0.30)" />
        </svg>
      </div>

      <div
        className="absolute select-none pointer-events-none"
        aria-hidden="true"
        style={{
          right: '3%',
          top: '50%',
          transform: 'translateY(-50%)',
          fontFamily: 'var(--font-heading),serif',
          fontSize: 'clamp(160px,20vw,280px)',
          fontWeight: 900,
          color: 'rgba(120,40,5,0.09)',
          letterSpacing: '-0.04em',
          lineHeight: 1,
        }}
      >
        15%
      </div>

      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        {PARTICLES.map((p) => (
          <div
            key={`${p.top}-${p.left}`}
            style={{
              position: 'absolute',
              top: p.top,
              left: p.left,
              width: `${p.size}px`,
              height: `${p.size}px`,
              background: p.color,
              borderRadius: '50%',
              boxShadow: p.glow !== 'none' ? p.glow : undefined,
              animation: 'ob-pulse 3.2s ease-in-out infinite',
              animationDelay: p.delay,
            }}
          />
        ))}
        <div style={{ position: 'absolute', top: '14%', left: '46%', fontSize: '8px', color: 'rgba(217,119,6,0.22)', animation: 'ob-pulse 4s ease-in-out infinite', animationDelay: '.4s' }}>✦</div>
        <div style={{ position: 'absolute', top: '80%', left: '66%', fontSize: '6px', color: 'rgba(217,119,6,0.18)', animation: 'ob-pulse 4s ease-in-out infinite', animationDelay: '2.1s' }}>✦</div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
        <div id="ob-content" ref={contentRef} style={{ maxWidth: '580px' }}>
          <div className={`ob-in${visible ? ' ob-on' : ''}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
            <div style={{ width: '18px', height: '1px', background: 'rgba(245,158,11,0.60)' }} />
            <p style={{ fontFamily: 'var(--font-heading),serif', fontSize: '8.5px', letterSpacing: '0.40em', textTransform: 'uppercase', color: 'rgba(245,158,11,0.88)', fontWeight: 700 }}>
              Limited Time Offer
            </p>
            <div style={{ width: '18px', height: '1px', background: 'rgba(245,158,11,0.60)' }} />
          </div>

          <div className={`ob-in${visible ? ' ob-on' : ''}`}>
            <h2 style={{ fontFamily: 'var(--font-heading),serif', fontSize: 'clamp(34px,6.2vw,54px)', fontWeight: 400, color: '#FFFFFF', lineHeight: 1.04, letterSpacing: '-0.025em', marginBottom: '12px' }}>
              Flat 15% <strong style={{ fontWeight: 800 }}>OFF</strong>
              <br />
              <span style={{ background: 'linear-gradient(96deg,#D97706,#F59E0B 45%,#D97706)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', fontWeight: 300 }}>
                On All Sacred Products
              </span>
            </h2>
          </div>

          <p className={`ob-in${visible ? ' ob-on' : ''}`} style={{ fontSize: '13px', lineHeight: 1.78, color: 'rgba(255,255,255,0.52)', maxWidth: '400px', marginBottom: '24px', fontWeight: 300, letterSpacing: '0.01em' }}>
            Premium Rudraksha, energised Yantras &amp; authentic gemstones at exclusive prices. Limited stock available.
          </p>

          <div className={`ob-in${visible ? ' ob-on' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
            {/* <a
              href="#"
              onMouseEnter={() => setCtaHover(true)}
              onMouseLeave={() => setCtaHover(false)}
              style={{
                position: 'relative',
                overflow: 'hidden',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '9px',
                padding: '0 28px',
                height: '44px',
                borderRadius: '999px',
                background: 'linear-gradient(100deg,#D97706,#F59E0B,#D97706)',
                backgroundSize: '200% 100%',
                backgroundPosition: ctaHover ? '100% 0' : '0 0',
                color: '#FFFFFF',
                fontFamily: 'var(--font-heading),serif',
                fontSize: '10px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.30em',
                textDecoration: 'none',
                border: 'none',
                cursor: 'pointer',
                boxShadow: ctaHover ? '0 8px 28px -4px rgba(217,119,6,0.70),0 0 0 1px rgba(245,158,11,0.35)' : '0 4px 20px -4px rgba(217,119,6,0.55),0 0 0 1px rgba(245,158,11,0.20)',
                transform: ctaHover ? 'scale(1.04)' : 'scale(1)',
                transition: 'all .28s cubic-bezier(.22,1,.36,1)',
                textShadow: '0 1px 2px rgba(120,40,5,0.45)',
              }}
            >
              <span
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '40%',
                  height: '100%',
                  background: 'linear-gradient(90deg,transparent,rgba(255,255,255,0.22),transparent)',
                  transform: ctaHover ? 'translateX(250%)' : 'translateX(-100%)',
                  transition: ctaHover ? 'transform .55s' : 'none',
                }}
              />
              Shop Now
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a> */}
            <a
              href={appUrl('shop', "products")}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '0 24px',
                height: '44px',
                borderRadius: '999px',
                background: 'transparent',
                color: 'rgba(255,255,255,0.70)',
                fontFamily: 'var(--font-heading),serif',
                fontSize: '10px',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.28em',
                textDecoration: 'none',
                border: '1.5px solid rgba(255,255,255,0.15)',
                cursor: 'pointer',
                transition: 'all .26s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.07)'
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.30)'
                e.currentTarget.style.color = 'rgba(255,255,255,0.90)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent'
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)'
                e.currentTarget.style.color = 'rgba(255,255,255,0.70)'
              }}
            >
              Browse All
            </a>
          </div>

          <div className={`ob-in${visible ? ' ob-on' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '18px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(245,158,11,0.70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <span style={{ fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.18em', color: 'rgba(255,255,255,0.35)' }}>100% Authentic</span>
            </div>
            <div style={{ width: '1px', height: '10px', background: 'rgba(255,255,255,0.10)' }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(245,158,11,0.70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span style={{ fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.18em', color: 'rgba(255,255,255,0.35)' }}>Energised by Maharaj Ji</span>
            </div>
            <div style={{ width: '1px', height: '10px', background: 'rgba(255,255,255,0.10)' }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(245,158,11,0.70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
              <span style={{ fontSize: '9px', textTransform: 'uppercase', letterSpacing: '0.18em', color: 'rgba(255,255,255,0.35)' }}>Free Shipping</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none" style={{ height: '60px', background: 'linear-gradient(to bottom,transparent,rgba(0,0,0,0.25))' }} />
    </section>
  )
}
